import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import {
    createImageSlide,
    createVideoSlide,
} from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const RedSetItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/1%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/2%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/3%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/4%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/5%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/6%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/7%401x.jpg'
    ),
    createVideoSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/redAnimVideo.mp4',
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/3%401x.jpg'
    ),
];
